export default __webpack_public_path__ + "static/media/billRun-cloud-logo.4adfda9e.png";